// extracted by mini-css-extract-plugin
export default {"root":"Logout_root__CjdQp","btn":"Logout_btn__jcIh-","wrapperTitle":"Logout_wrapperTitle__9UjBX","wrapperBtn":"Logout_wrapperBtn__whuf7"};